export default __webpack_public_path__ + "static/Poppins-Medium-f0a9bfb06ed7d95d8f8e5f4d36e47520.woff2";